var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.warnings && _vm.warnings.length > 0)?_vm._l((_vm.warnings),function(warning,index){return _c('warning',{key:index,attrs:{"warning":warning}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }